import { http } from '../../core/services/http';

export const getLanguageOptions = () => http.get('/common/systemTypes/languages').then(response => response);

export const saveLanguageSetting = (languageId: number, vendorId: number, userId: number) =>
  http.put(`vendors/${vendorId}/users/${userId}/language`, languageId);
